import React from 'react';
import { 
  Clock, 
  Package, 
  Truck, 
  CheckCircle, 
  XCircle, 
  AlertCircle,
  RefreshCw 
} from 'lucide-react';

interface ShipmentStatusBadgeProps {
  status: string;
  className?: string;
}

const ShipmentStatusBadge: React.FC<ShipmentStatusBadgeProps> = ({ 
  status, 
  className = '' 
}) => {
  const statusConfig = {
    PENDING: {
      color: 'bg-gray-100 text-gray-800',
      icon: Clock,
      label: 'Pending'
    },
    CREATED: {
      color: 'bg-blue-100 text-blue-800',
      icon: Package,
      label: 'Created'
    },
    PICKUP_SCHEDULED: {
      color: 'bg-purple-100 text-purple-800',
      icon: Clock,
      label: 'Pickup Scheduled'
    },
    PICKED_UP: {
      color: 'bg-indigo-100 text-indigo-800',
      icon: Package,
      label: 'Picked Up'
    },
    IN_TRANSIT: {
      color: 'bg-yellow-100 text-yellow-800',
      icon: Truck,
      label: 'In Transit'
    },
    DELIVERED: {
      color: 'bg-green-100 text-green-800',
      icon: CheckCircle,
      label: 'Delivered'
    },
    RETURNED: {
      color: 'bg-orange-100 text-orange-800',
      icon: RefreshCw,
      label: 'Returned'
    },
    CANCELLED: {
      color: 'bg-red-100 text-red-800',
      icon: XCircle,
      label: 'Cancelled'
    },
    LOST: {
      color: 'bg-red-200 text-red-900',
      icon: AlertCircle,
      label: 'Lost'
    },
    DAMAGED: {
      color: 'bg-red-200 text-red-900',
      icon: AlertCircle,
      label: 'Damaged'
    }
  };

  const config = statusConfig[status as keyof typeof statusConfig] || statusConfig.PENDING;
  const IconComponent = config.icon;

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color} ${className}`}>
      <IconComponent className="h-3 w-3 mr-1" />
      {config.label}
    </span>
  );
};

export default ShipmentStatusBadge;